// src/api/dashboardApi.js
import { fetchWithAuth } from "./fetchWithAuth";

export async function fetchLandOwnerDashboard() {
  const res = await fetchWithAuth("/dashboards/land-owner");

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    console.error("Dashboard API failed:", res.status, text);
    throw new Error(
      `Dashboard API failed (${res.status}): ${text}`
    );
  }

  return res.json();
}